<template>
    <div class="privacidade">
        <PageTitle icon="fa fa-home" main="Política de Privacidade" sub="Última atualização: 24/09/2024" />
        
       
        <p>
            Esta Política de Privacidade descreve como ML 18 TECNOLOGIA LTDA ("nós", "nosso") coleta, usa e protege as informações pessoais dos usuários ("você") ao utilizar nosso aplicativo disponível na Google Play Store.
        </p>

        <div class="card mb-3">
            <div class="card-body">
                <h2>1. Informações que coletamos</h2>
                <ul>
                    <li><strong>Dados de Cadastro:</strong> CPF, Nome, e-mail, telefone.</li>
                    <li><strong>Informações de Uso:</strong> Dados sobre como você utiliza o aplicativo, como tempo de uso, funcionalidades acessadas e interações.</li>
                </ul>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h2>2. Como Usamos Suas Informações</h2>
                <ul>
                    <li>Melhorar e personalizar sua experiência no aplicativo.</li>
                    <li>Enviar atualizações e informações relacionadas ao nosso serviço.</li>
                    <li>Analisar o uso do aplicativo e desenvolver novos produtos e serviços.</li>
                </ul>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h2>3. Compartilhamento de Informações</h2>
                <p>
                    Nós não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto nas seguintes situações:
                </p>
                <ul>
                    <li>Com prestadores de serviços que ajudam na operação do aplicativo (por exemplo, serviços de análise).</li>
                    <li>Quando exigido por lei ou para proteger nossos direitos.</li>
                </ul>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h2>4. Segurança das Informações</h2>
                <p>
                    Tomamos medidas razoáveis para proteger suas informações pessoais contra acesso não autorizado, uso ou divulgação. No entanto, nenhum método de transmissão pela internet ou armazenamento eletrônico é 100% seguro.
                </p>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h2>5. Seus Direitos</h2>
                <p>Você tem o direito de:</p>
                <ul>
                    <li>Acessar, corrigir ou excluir suas informações pessoais.</li>
                    <li>Solicitar a limitação do processamento de suas informações.</li>
                    <li>Retirar seu consentimento a qualquer momento.</li>
                </ul>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h2>6. Alterações nesta Política</h2>
                <p>
                    Podemos atualizar esta Política de Privacidade ocasionalmente. Notificaremos você sobre alterações significativas, publicando a nova política no aplicativo. Recomendamos que você revise esta política regularmente.
                </p>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h2>7. Contato</h2>
                <p>
                    Se você tiver alguma dúvida sobre esta Política de Privacidade ou sobre nossas práticas de privacidade, entre em contato conosco em:
                </p>
                <ul>
                    <li><strong>E-mail:</strong> marcoslesser@ml18.com.br</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
export default {
    name: 'Privacidade',
    components: { PageTitle },
    data: function() {
        return {};
    },
    methods: {},
    mounted() {
        // this.getStats()
    }
}
</script>

<style>
.privacidade {
    padding: 20px;
    font-family: Arial, sans-serif;
    text-align: center; /* Centraliza o texto */
}

.card {
    text-align: left; /* Texto alinhado à esquerda dentro do card */
}

h1 {
    font-size: 24px;
    margin-bottom: 10px;
}

h2 {
    font-size: 20px;
    margin-top: 15px;
}

p {
    margin-bottom: 10px;
    line-height: 1.6;
}

ul {
    margin: 10px 0 10px 0; /* Remove o espaçamento à esquerda */
    padding: 0; /* Remove o padding padrão da lista */
    list-style-type: none; /* Remove as bolinhas da lista */
}

li {
    margin-bottom: 5px;
}
</style>
